import { z } from 'zod';

/**
 * Base email validation schema without transformation.
 * Use this with drizzle-zod createInsertSchema/createSelectSchema.
 */
export const emailBaseSchema = z
  .string()
  .trim()
  .min(1, 'Email is required')
  .email('Invalid email format');

/**
 * Consolidated email schema used across the entire application.
 * Automatically transforms emails to lowercase and trims whitespace for consistency.
 *
 * All email addresses in this application are stored and processed as lowercase
 * to ensure consistency and prevent duplicate accounts with different casing.
 * Whitespace is trimmed to handle accidental spaces during input.
 *
 * Use this for form validations and API schemas.
 */
export const emailSchema = emailBaseSchema.toLowerCase();

/**
 * Optional email schema with automatic lowercase transformation and trimming.
 * Use for fields where email is not required.
 */
export const optionalEmailSchema = emailBaseSchema.toLowerCase().optional();

/**
 * Type representing a validated and normalized email address.
 * Always guaranteed to be lowercase.
 */
export type Email = z.infer<typeof emailSchema>;
